export function formatNotificationAge(createdAt: string, now: Date = new Date()): string {
  const createdMs = new Date(createdAt).getTime();
  if (Number.isNaN(createdMs)) {
    return '0m';
  }

  const elapsedMinutes = Math.floor(Math.max(0, now.getTime() - createdMs) / 60_000);
  if (elapsedMinutes < 60) {
    return `${Math.max(1, elapsedMinutes)}m`;
  }

  const elapsedHours = Math.floor(elapsedMinutes / 60);
  if (elapsedHours < 24) {
    return `${elapsedHours}h`;
  }

  const elapsedDays = Math.floor(elapsedHours / 24);
  return `${elapsedDays}d`;
}
